import { useMutation } from "@apollo/client/react";
import { SET_LG_STATUS_ON_INVOICE } from "../../mutations/invoices/setLgStatusOnInvoice";
import GET_CLIENT_ASSESSMENT_INVOICES from "../../queries/invoices/getClientAssessmentInvoices";
import GET_INVOICE_DELIVERY_APPROVALS from "../../queries/invoices/getInvoiceDeliveryApprovals";

export const useSetLgStatusOnInvoice = ({
  onCompleted,
  onError,
  noRefetch = false,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
  noRefetch?: boolean;
}) => {
  const [setLgStatusOnInvoice, { data, loading, error }] = useMutation<{
    invoice: {
      setLgStatusOnInvoice: {
        success: boolean;
        errorMessage?: string;
        invoiceId?: string;
      };
    };
  }>(SET_LG_STATUS_ON_INVOICE, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: noRefetch
      ? []
      : [GET_CLIENT_ASSESSMENT_INVOICES, GET_INVOICE_DELIVERY_APPROVALS],
    awaitRefetchQueries: true,
  });

  return { setLgStatusOnInvoice, data, loading, error };
};
